// products.js

const CATEGORY_LINKS = {
  default:
    "/t/foils-and-adhesive-films/adhesive-film-permanent/solid-colored-self-adhesive-film/",
  frosted:
    "/t/foils-and-adhesive-films/adhesive-film-permanent/frosted-glass-film/",
  dekor:
    "/t/foils-and-adhesive-films/adhesive-film-permanent/patterned-self-adhesive-film/",
};

const THUMB_URL_BASE = "https://cdn.myfolie.de/media/products/thumbs/";

const productsData = [
  {
    type: "matt",
    category: "default",
    products: [
      {
        slug: "klebefolie-matt-weiss",
        name: "Klebefolie Weiß (matt)",
        thumb_url: "1._wei_631_010.png",
      },
      {
        slug: "klebefolie-matt-schwarz",
        name: "Klebefolie Schwarz (matt)",
        thumb_url: "59._schwarz_631_070.png",
      },
      {
        slug: "klebefolie-matt-goldgelb",
        name: "Klebefolie Goldgelb (matt)",
        thumb_url: "2._goldgelb_631_020.png",
      },
      {
        slug: "klebefolie-matt-signalgelb",
        name: "Klebefolie Signalgelb (matt)",
        thumb_url: "3._signalgelb_631_019.png",
      },
      {
        slug: "klebefolie-matt-gelb",
        name: "Klebefolie Gelb (matt)",
        thumb_url: "4._gelb_631_021.png",
      },
      {
        slug: "klebefolie-matt-shellgelb",
        name: "Klebefolie Shellgelb (matt)",
        thumb_url: "5._shellgelb_631_022.png",
      },
      {
        slug: "klebefolie-matt-schwefelgelb",
        name: "Klebefolie Schwefelgelb (matt)",
        thumb_url: "6._schwefelgelb_631_025.png",
      },
      {
        slug: "klebefolie-matt-dunkelrot",
        name: "Klebefolie Dunkelrot (matt)",
        thumb_url: "7._dunkelrot_631_030_1.png",
      },
      {
        slug: "klebefolie-matt-rot",
        name: "Klebefolie Rot (matt)",
        thumb_url: "8._rot_631_031.png",
      },
      {
        slug: "klebefolie-matt-hellrot",
        name: "Klebefolie Hellrot (matt)",
        thumb_url: "9._hellrot_631_032.png",
      },
      {
        slug: "klebefolie-matt-orange",
        name: "Klebefolie Orange (matt)",
        thumb_url: "11._orange_631_034.png",
      },
      {
        slug: "klebefolie-matt-hellrotorange",
        name: "Klebefolie Hellrotorange (matt)",
        thumb_url: "12._hellrotorange_036.png",
      },
    ],
  },
  {
    type: "glossy",
    category: "default",
    products: [
      {
        slug: "klebefolie-glaenzend-weiss",
        name: "Klebefolie Weiß (glänzend)",
        thumb_url: "1._wei_651_010.png",
      },
      {
        slug: "klebefolie-glaenzend-schwarz",
        name: "Klebefolie Schwarz (glänzend)",
        thumb_url: "50._schwarz_651_070.png",
      },
      {
        slug: "klebefolie-glaenzend-goldgelb",
        name: "Klebefolie Goldgelb (glänzend)",
        thumb_url: "2._goldgelb_651_020.png",
      },
      {
        slug: "klebefolie-glaenzend-signalgelb",
        name: "Klebefolie Signalgelb (glänzend)",
        thumb_url: "3._signalgelb_019.png",
      },
      {
        slug: "klebefolie-glaenzend-gelb",
        name: "Klebefolie Gelb (glänzend)",
        thumb_url: "4._gelb_651_021.png",
      },
      {
        slug: "klebefolie-glaenzend-shellgelb",
        name: "Klebefolie Shellgelb (glänzend)",
        thumb_url: "5._shellgelb_651_022.png",
      },
      {
        slug: "klebefolie-glaenzend-schwefelgelb",
        name: "Klebefolie Schwefelgelb (glänzend)",
        thumb_url: "6._schwefelgelb_651_025.png",
      },
      {
        slug: "klebefolie-glaenzend-purpurrot",
        name: "Klebefolie Purpurrot (glänzend)",
        thumb_url: "7._purpurrot_651_026.png",
      },
      {
        slug: "klebefolie-burgundy-glanzend",
        name: "Klebefolie Burgundy (glänzend)",
        thumb_url: "8._burgundy_651_312.png",
      },
      {
        slug: "klebefolie-glaenzend-dunkelrot",
        name: "Klebefolie Dunkelrot (glänzend)",
        thumb_url: "9._dunkelrot_651_030.png",
      },
      {
        slug: "klebefolie-glaenzend-rot",
        name: "Klebefolie Rot (glänzend)",
        thumb_url: "10._rot_651_031.png",
      },
      {
        slug: "klebefolie-glaenzend-hellrot",
        name: "Klebefolie Hellrot (glänzend)",
        thumb_url: "11._hellrot_651_032.png",
      },
    ],
  },
  {
    type: "transparent",
    category: "default",
    products: [
      {
        slug: "klebefolie-gelb-transparent-glanzend",
        name: "Klebefolie Gelb Transparent (glänzend)",
        thumb_url: "2_gelb_021.jpg",
      },
      {
        slug: "klebefolie-verkehrsgelb-transparent-glanzend",
        name: "Klebefolie Verkehrsgelb Transparent (glänzend)",
        thumb_url: "3_verkehrsgelb_216.jpg",
      },
      {
        slug: "klebefolie-goldgelb-transparent-glanzend",
        name: "Klebefolie Goldgelb Transparent (glänzend)",
        thumb_url: "4_goldgelb_020.jpg",
      },
      {
        slug: "klebefolie-orange-transparent-glanzend",
        name: "Klebefolie Orange Transparent (glänzend)",
        thumb_url: "5_orange_034.jpg",
      },
      {
        slug: "klebefolie-rosa-transparent-glanzend",
        name: "Klebefolie Rosa Transparent (glänzend)",
        thumb_url: "6_rosa_085.jpg",
      },
      {
        slug: "klebefolie-lachsrot-transparent-glanzend",
        name: "Klebefolie Lachsrot Transparent (glänzend)",
        thumb_url: "7_lachrot_089.jpg",
      },
      {
        slug: "klebefolie-orangerot-transparent-glanzend",
        name: "Klebefolie Orangerot Transparent (glänzend)",
        thumb_url: "8_orangerot_047.jpg",
      },
      {
        slug: "klebefolie-rotorange-transparent-glanzend",
        name: "Klebefolie Rotorange Transparent (glänzend)",
        thumb_url: "9_rotorange_033.jpg",
      },
      {
        slug: "klebefolie-hellrot-transparent-glanzend",
        name: "Klebefolie Hellrot Transparent (glänzend)",
        thumb_url: "10_hellrot_032.jpg",
      },
      {
        slug: "klebefolie-rot-transparent-glanzend",
        name: "Klebefolie Rot Transparent (glänzend)",
        thumb_url: "11_rot_031.jpg",
      },
      {
        slug: "klebefolie-dunkelrot-transparent-glanzend",
        name: "Klebefolie Dunkelrot Transparent (glänzend)",
        thumb_url: "12_dunkelrot_030.jpg",
      },
      {
        slug: "klebefolie-pink-transparent-glanzend",
        name: "Klebefolie Pink Transparent (glänzend)",
        thumb_url: "13_pink_041.jpg",
      },
    ],
  },
  {
    type: "neon",
    category: "default",
    products: [
      {
        slug: "klebefolie-neon-grun",
        name: "Klebefolie Neon Grün",
        thumb_url: "7._neongr_n_6510_069.png",
      },
      {
        slug: "klebefolie-neon-orange",
        name: "Klebefolie Neon Orange",
        thumb_url: "2._neonorange_6510_037.png",
      },
      {
        slug: "klebefolie-neon-pink",
        name: "Klebefolie Neon Pink",
        thumb_url: "6._neonpink_6510_046.png",
      },
      {
        slug: "klebefolie-neon-rotorange",
        name: "Klebefolie Neon Rotorange",
        thumb_url: "3._neonrotorange_6510_038.png",
      },
    ],
  },
  {
    type: "frosted",
    category: "default",
    products: [
      {
        slug: "klebefolie-milchglasfolie-silber-feinstruktur-etched",
        name: "Milchglasfolie Silber (Feinstruktur/ Etched)",
        thumb_url: "ausschnitt_1_korrigiert.png",
      },
      {
        slug: "klebefolie-milchglasfolie-silbergrau-frosted",
        name: "Milchglasfolie Silbergrau (Frosted)",
        thumb_url: "silbergrau_090_8810.png",
      },
      {
        slug: "klebefolie-milchglasfolie-gold-frosted",
        name: "Milchglasfolie Gold (Frosted)",
        thumb_url: "gold_091_8810.png",
      },
      {
        slug: "klebefolie-milchglasfolie-rosa-frosted",
        name: "Milchglasfolie Rosa (Frosted)",
        thumb_url: "rosa_085_8810.png",
      },
      {
        slug: "klebefolie-milchglasfolie-mint-frosted",
        name: "Milchglasfolie Mint (Frosted)",
        thumb_url: "mint_055_8810.png",
      },
      {
        slug: "klebefolie-milchglasfolie-blau-frosted",
        name: "Milchglasfolie Lichtblau (Frosted)",
        thumb_url: "lichtblau_056_8810.png",
      },
    ],
  },
  {
    type: "highperformance",
    category: "default",
    products: [
      {
        slug: "klebefolie-weiss-high-performance-glanzend",
        name: "Klebefolie Weiß High Performance (glänzend)",
        thumb_url: "1_wei_010_3.png",
      },
      {
        slug: "klebefolie-schwarz-high-performance-glanzend",
        name: "Klebefolie Schwarz High Performance (glänzend)",
        thumb_url: "102_schwarz_070_1.png",
      },
      {
        slug: "klebefolie-goldgelb-high-performance-glanzend",
        name: "Klebefolie Goldgelb High Performance (glänzend)",
        thumb_url: "2_goldgelb_020.png",
      },
      {
        slug: "klebefolie-dottergelb-high-performance-glanzend",
        name: "Klebefolie Dottergelb High Performance (glänzend)",
        thumb_url: "3_dottergelb_219.png",
      },
      {
        slug: "klebefolie-strohgelb-high-performance-glanzend",
        name: "Klebefolie Strohgelb High Performance (glänzend)",
        thumb_url: "4_strohgelb_203.png",
      },
      {
        slug: "klebefolie-sonnengelb-high-performance-glanzend",
        name: "Klebefolie Sonnengelb High Performance (glänzend)",
        thumb_url: "5_sonnengelb_211.png",
      },
      {
        slug: "klebefolie-signalgelb-high-performance-glanzend",
        name: "Klebefolie Signalgelb High Performance (glänzend)",
        thumb_url: "6_signalgelb_019.png",
      },
      {
        slug: "klebefolie-postgelb-high-performance-glanzend",
        name: "Klebefolie Postgelb High Performance (glänzend)",
        thumb_url: "7_postgelb_208.png",
      },
      {
        slug: "klebefolie-maisgelb-high-performance-glanzend",
        name: "Klebefolie Maisgelb High Performance (glänzend)",
        thumb_url: "8_maisgelb_209.png",
      },
      {
        slug: "klebefolie-gelb-high-performance-glanzend",
        name: "Klebefolie Gelb High Performance (glänzend)",
        thumb_url: "9_gelb_021.png",
      },
      {
        slug: "klebefolie-verkehrsgelb-high-performance-glanzend",
        name: "Klebefolie Verkehrsgelb High Performance (glänzend)",
        thumb_url: "10_verkehrsgelb_216.png",
      },
      {
        slug: "klebefolie-shellgelb-high-performance-glanzend",
        name: "Klebefolie Shellgelb High Performance (glänzend)",
        thumb_url: "11_shellgelb_022.png",
      },
    ],
  },
  {
    type: "metalic",
    category: "default",
    products: [
      {
        slug: "klebefolie-schwarz-metallic-premium-glanzend",
        name: "Klebefolie Schwarz metallic Premium (glänzend)",
        thumb_url: "1_schwarz_metallic_704.jpg",
      },
      {
        slug: "klebefolie-silber-metallic-premium-glanzend",
        name: "Klebefolie Silber metallic Premium (glänzend)",
        thumb_url: "10_silber_metallic_906.jpg",
      },
      {
        slug: "klebefolie-gold-metallic-premium-glanzend",
        name: "Klebefolie Gold metallic Premium (glänzend)",
        thumb_url: "19_gold_metallic_922.jpg",
      },
      {
        slug: "klebefolie-kupfer-premium-glanzend",
        name: "Klebefolie Kupfer Premium (glänzend)",
        thumb_url: "14_kupfer_092.jpg",
      },
      {
        slug: "klebefolie-mint-metallic-premium-glanzend",
        name: "Klebefolie Mint metallic Premium (glänzend)",
        thumb_url: "48_mint_metallic_674.jpg",
      },
      {
        slug: "klebefolie-turkis-metallic-premium-glanzend",
        name: "Klebefolie Türkis metallic Premium (glänzend)",
        thumb_url: "38_t_rkis_metallic_199.jpg",
      },
      {
        slug: "klebefolie-azurblau-metallic-premium-glanzend",
        name: "Klebefolie Azurblau metallic Premium (glänzend)",
        thumb_url: "36_azurblau_197.jpg",
      },
      {
        slug: "klebefolie-rot-metallic-premium-glanzend",
        name: "Klebefolie Rot metallic Premium (glänzend)",
        thumb_url: "26_rot_metallic_367.jpg",
      },
      {
        slug: "klebefolie-laubgrun-metallic-premium-glanzend",
        name: "Klebefolie Laubgrün metallic Premium (glänzend)",
        thumb_url: "43_laubgr_n_679.jpg",
      },
      {
        slug: "klebefolie-nachtblau-metallic-premium-glanzend",
        name: "Klebefolie Nachtblau metallic Premium (glänzend)",
        thumb_url: "34_nachtblau_196.jpg",
      },
      {
        slug: "klebefolie-graphit-metallic-premium-glanzend",
        name: "Klebefolie Graphit metallic Premium (glänzend)",
        thumb_url: "6_graphit_metallic_932.jpg",
      },
      {
        slug: "klebefolie-hellbraun-metallic-premium-glanzend",
        name: "Klebefolie Hellbraun metallic Premium (glänzend)",
        thumb_url: "22_hellbraun_metallic_923.jpg",
      },
    ],
  },
  {
    type: "dekor",
    category: "dekor",
    products: [
      {
        slug: "marmor-optik-schwarz-weiss-fischgratmuster-klebefolie-dekor-muster",
        name: "Marmor Optik Schwarz Weiß Fischgrätmuster - Klebefolie Dekor Muster",
        thumb_url: "marmor_optik_schwarz_wei_fischgr_tmuster_klebeeck.png",
      },
      {
        slug: "marmor-optik-klebefolie-dekor-muster",
        name: "Marmor Optik - Klebefolie Dekor Muster",
        thumb_url: "marmor_optik_vorschau_klebeeck.png",
      },
      {
        slug: "rotlicher-fliesenspiegel-klebefolie-dekor-muster",
        name: "rötlicher Fliesenspiegel - Klebefolie Dekor Muster",
        thumb_url: "r_tlicher_fliesenspiegel_vorschau_1.png",
      },
      {
        slug: "wildes-gestein-klebefolie-dekor-muster",
        name: "wildes Gestein - Klebefolie Dekor Muster",
        thumb_url: "wildes_gestein_vorschau_1.png",
      },
      {
        slug: "zebrastil-klebefolie-dekor-muster",
        name: "Zebrastil - Klebefolie Dekor Muster",
        thumb_url: "zebrastil_vorschau_1.png",
      },
      {
        slug: "geometrische-pfeile-grau-blau-klebefolie-dekor-muster",
        name: "geometrische Pfeile Grau Blau - Klebefolie Dekor Muster",
        thumb_url: "geometrische_pfeile_grau_blau_vorschau_1.png",
      },
      {
        slug: "konfetti-rosa-rot-orange-klebefolie-dekor-muster",
        name: "Konfetti Rosa Rot Orange - Klebefolie Dekor Muster",
        thumb_url: "konfetti_rosa_rot_orange_vorschau_1.png",
      },
      {
        slug: "blumenwiese-ganseblumchen-klebefolie-dekor-muster",
        name: "Blumenwiese Gänseblümchen - Klebefolie Dekor Muster",
        thumb_url: "blumenwiese_g_nsebl_mchen_vorschau_1.png",
      },
      {
        slug: "baumrinde-kieferstil-klebefolie-dekor-muster",
        name: "Baumrinde Kieferstil - Klebefolie Dekor Muster",
        thumb_url: "baumrinde_kieferstil_vorschau_1.png",
      },
      {
        slug: "donuts-mit-streusel-auf-weiss-klebefolie-dekor-muster",
        name: "Donuts mit Streusel auf Weiß - Klebefolie Dekor Muster",
        thumb_url: "donuts_mit_streusel_auf_wei_vorschau_1.png",
      },
      {
        slug: "florales-muster-sommerbluten-klebefolie-dekor-muster",
        name: "florales Muster Sommerblüten - Klebefolie Dekor Muster",
        thumb_url: "florales_muster_sommerbl_ten_vorschau_1.png",
      },
      {
        slug: "anker-streifen-hellblau-rot-klebefolie-dekor-muster",
        name: "Anker Streifen Hellblau Rot - Klebefolie Dekor Muster",
        thumb_url: "muster_anker_streifen_hellblau_rot._vorschau_1.png",
      },
    ],
  },
  {
    type: "premium",
    category: "default",
    products: [
      {
        slug: "klebefolie-weiss-premium-glanzend",
        name: "Klebefolie Weiß Premium (glänzend)",
        thumb_url: "1_wei_010_4.png",
      },
      {
        slug: "klebefolie-schwarz-premium-glanzend",
        name: "Klebefolie Schwarz Premium (glänzend)",
        thumb_url: "2_schwarz_070.png",
      },
      {
        slug: "klebefolie-krokusgelb-premium-glanzend",
        name: "Klebefolie Krokusgelb Premium (glänzend)",
        thumb_url: "3_krokusgelb_201.png",
      },
      {
        slug: "klebefolie-verkehrsgelb-premium-glanzend",
        name: "Klebefolie Verkehrsgelb Premium (glänzend)",
        thumb_url: "4_verkehrsblau_216.png",
      },
      {
        slug: "klebefolie-maisgelb-premium-glanzend",
        name: "Klebefolie Maisgelb Premium (glänzend)",
        thumb_url: "5_maisgelb_209.png",
      },
      {
        slug: "klebefolie-dottergelb-premium-glanzend",
        name: "Klebefolie Dottergelb Premium (glänzend)",
        thumb_url: "6_dottergelb_219.png",
      },
      {
        slug: "klebefolie-goldgelb-premium-glanzend",
        name: "Klebefolie Goldgelb Premium (glänzend)",
        thumb_url: "7_goldgelb_255.png",
      },
      {
        slug: "klebefolie-melonengelb-premium-glanzend",
        name: "Klebefolie Melonengelb Premium (glänzend)",
        thumb_url: "8_melonengelb_204.png",
      },
      {
        slug: "klebefolie-postgelb-premium-glanzend",
        name: "Klebefolie Postgelb Premium (glänzend)",
        thumb_url: "9_postgelb_208.png",
      },
      {
        slug: "klebefolie-signalgelb-premium-glanzend",
        name: "Klebefolie Signalgelb Premium (glänzend)",
        thumb_url: "10_signalgelb_019.png",
      },
      {
        slug: "klebefolie-pastellorange-premium-glanzend",
        name: "Klebefolie Pastellorange Premium (glänzend)",
        thumb_url: "17_pastellorange_035.png",
      },
      {
        slug: "klebefolie-tieforange-premium-glanzend",
        name: "Klebefolie Tieforange Premium (glänzend)",
        thumb_url: "18_tieforange_332.png",
      },
    ],
  },
];

// Transforming the data array into an object for easier access
const products = productsData.reduce((acc, { type, category, products }) => {
  acc[type] = {
    category_link: CATEGORY_LINKS[category] || CATEGORY_LINKS.default,
    products: products.map((product) => ({
      ...product,
      thumb_url: `${THUMB_URL_BASE}${product.thumb_url}`,
    })),
  };
  return acc;
}, {});

export default products;
